/**
 * Scavenged greaves. Cheap cover for the location a rifle finds least, and the piece a new
 * character can afford to be wearing.
 */

import type { ArmorItem } from '@/sim/items/itemContract';

export const SCAVENGED_GREAVES = {
  id: 'scavengedGreaves',
  kind: 'armor',
  label: 'Scavenged greaves',
  description: 'Road signage, bent to fit a shin. The reflective coating is a mixed blessing.',
  rarity: 'common',
  weightKg: 2.4,
  stackLimit: 1,
  equip: {
    slots: ['legs'],
    statDeltas: {},
    armor: { threshold: 2, rating: 12 },
    damageModifiers: [],
  },
} as const satisfies ArmorItem;
